"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObfuscatedCodeFileUtils = void 0;
const fs = __importStar(require("fs"));
const mkdirp = __importStar(require("mkdirp"));
const path = __importStar(require("path"));
const StringSeparator_1 = require("../../enums/StringSeparator");
const JavaScriptObfuscatorCLI_1 = require("../JavaScriptObfuscatorCLI");
class ObfuscatedCodeFileUtils {
    constructor(inputPath, options) {
        this.inputPath = path.normalize(inputPath);
        this.options = options;
    }
    getOutputCodePath(filePath) {
        const normalizedFilePath = path.normalize(filePath);
        const normalizedRawOutputPath = this.options.output ? path.normalize(this.options.output) : null;
        if (!normalizedRawOutputPath) {
            return normalizedFilePath
                .split(StringSeparator_1.StringSeparator.Dot)
                .map((value, index) => {
                return index === 0 ? `${value}${JavaScriptObfuscatorCLI_1.JavaScriptObfuscatorCLI.obfuscatedFilePrefix}` : value;
            })
                .join(StringSeparator_1.StringSeparator.Dot);
        }
        const rawInputPathStats = fs.lstatSync(this.inputPath);
        const outputPathExtName = path.extname(normalizedRawOutputPath);
        const isDirectoryRawInputPath = rawInputPathStats.isDirectory();
        const isDirectoryRawOutputPath = !JavaScriptObfuscatorCLI_1.JavaScriptObfuscatorCLI.availableInputExtensions.includes(outputPathExtName);
        if (isDirectoryRawInputPath) {
            if (isDirectoryRawOutputPath) {
                const parsedNormalizedFilePath = path.parse(normalizedFilePath);
                if (!parsedNormalizedFilePath.dir.endsWith('/') && this.inputPath.endsWith('/')) {
                    parsedNormalizedFilePath.dir += '/';
                }
                const baseOutputPath = path.join(parsedNormalizedFilePath.dir.replace(this.inputPath, ''), parsedNormalizedFilePath.base);
                return path.join(normalizedRawOutputPath, baseOutputPath);
            }
            else {
                throw new Error('Output path for directory obfuscation should be a directory path');
            }
        }
        else {
            if (isDirectoryRawOutputPath) {
                return path.join(normalizedRawOutputPath, path.basename(filePath));
            }
            else {
                return normalizedRawOutputPath;
            }
        }
    }
    getOutputSourceMapPath(outputCodePath, sourceMapFileName = '') {
        if (!outputCodePath) {
            throw new Error('Output code path is empty');
        }
        let normalizedOutputCodePath = path.normalize(outputCodePath);
        let parsedOutputCodePath = path.parse(normalizedOutputCodePath);
        if (!parsedOutputCodePath.ext && !sourceMapFileName) {
            throw new Error('Source map file name should be set when output code path is a directory path');
        }
        if (sourceMapFileName) {
            const indexOfLastSeparator = normalizedOutputCodePath.lastIndexOf(path.sep);
            let sourceMapPath;
            if (parsedOutputCodePath.ext) {
                const isFilePathWithDirectory = indexOfLastSeparator > 0;
                sourceMapPath = isFilePathWithDirectory ? normalizedOutputCodePath.slice(0, indexOfLastSeparator) : '';
            }
            else {
                sourceMapPath = normalizedOutputCodePath;
            }
            const normalizedSourceMapFilePath = sourceMapFileName.replace(/^[a-zA-Z]:\\*/, '');
            normalizedOutputCodePath = path.join(sourceMapPath, normalizedSourceMapFilePath);
        }
        if (!/\.js\.map$/.test(normalizedOutputCodePath)) {
            parsedOutputCodePath = path.parse(normalizedOutputCodePath);
            const outputCodePathWithoutExtension = path.join(parsedOutputCodePath.dir, parsedOutputCodePath.name);
            normalizedOutputCodePath = `${outputCodePathWithoutExtension}.js.map`;
        }
        else if (/\.js$/.test(normalizedOutputCodePath)) {
            normalizedOutputCodePath += '.map';
        }
        return normalizedOutputCodePath;
    }
    writeFile(outputPath, data) {
        mkdirp.sync(path.dirname(outputPath));
        fs.writeFileSync(outputPath, data, {
            encoding: JavaScriptObfuscatorCLI_1.JavaScriptObfuscatorCLI.encoding
        });
    }
}
exports.ObfuscatedCodeFileUtils = ObfuscatedCodeFileUtils;
